import { Component, Input, signal } from '@angular/core';
import { IAdvertisementEntity } from '@web-nx-ng-tsc/web-shared-data-access';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

@Component({
  selector: 'web-promo-shared-pattern-lib-banner-carousel',
  imports: [CarouselModule],
  templateUrl: './lib-banner-carousel.component.html',
  styleUrl: './lib-banner-carousel.component.scss',
})
export class LibBannerCarouselComponent {
  @Input() set data(value: IAdvertisementEntity) {
    this.dataSignal.set(value);
  }

  public readonly replaceBucket = new ReplaceBucket();

  dataSignal = signal<any>({
    carouselOptions: undefined,
    carouselSlide: [],
  });

  // replaceBucket(url: string): string {
  //   const s3BaseUrl = NG_APP_S3_PUB_BULB_URL.replace('/public', '') + '/';

  //   if (url.startsWith(s3BaseUrl)) {
  //     const pathAfterBucket = url.replace(s3BaseUrl, '');
  //     return NG_APP_S3_PUB_BULB_URL + '/' + pathAfterBucket;
  //   }

  //   return url;
  // }
}
